import { dashboardT } from '../../../../../../lib/messages';
import {
  LineItemTargetingCsvIssue,
  type LineItemTargetingCsvFailure,
} from '../../../saveLineItemWithTargetingCsv';

export function LineItemTargetingCsvNotice({
  collection,
  count,
  failure,
}: {
  collection: string;
  count: number;
  failure: LineItemTargetingCsvFailure | undefined;
}) {
  switch (failure?.issue) {
    case LineItemTargetingCsvIssue.UnknownOutcome:
      return (
        <p role="alert" className="text-destructive text-xs">
          {dashboardT('targeting.lineItemCsv.unknownOutcome', { collection, count })}
        </p>
      );
    case LineItemTargetingCsvIssue.Rejected:
      return (
        <ul role="alert" className="text-destructive grid gap-1 text-xs">
          {failure.messages.map((message, index) => (
            <li key={String(index) + message}>{message}</li>
          ))}
        </ul>
      );
    case undefined:
      return (
        <p className="text-muted-foreground text-xs">
          {dashboardT('targeting.lineItemCsv.replaceWarning', { collection })}
        </p>
      );
  }
}
